import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import { AuthLayout } from '@bounded/ui/auth-layout';
import { Button } from '@bounded/ui/primitives';
import { useT } from '../i18n';

export const Route = createFileRoute('/forbidden')({ component: Forbidden });

/** Signed in on this origin, but the server gave no admin role. A dead end on purpose: no admin chrome. */
function Forbidden() {
  const t = useT();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const signOut = useMutation({ mutationFn: () => api.signOut(), onSettled: async () => { queryClient.clear(); await navigate({ to: '/sign-in', search: { next: undefined } }); } });
  return (
    <AuthLayout title={t.auth.forbiddenTitle}>
      <p className="text-graphite">{t.auth.forbiddenBody}</p>
      <div><Button onClick={() => signOut.mutate()} disabled={signOut.isPending}>{t.auth.signOut}</Button></div>
    </AuthLayout>
  );
}
